<template>
    <v-card class="myprofile-popup">
            <v-card-title primary-title >
                {{memberProfileConstants.ACCOMPLISHMENT.EDIT}} {{headerLabel}}
                <i class="fas fa-times" data-qe-id="close_dialog_btn" @click="cancel()"></i>
            </v-card-title>
            <v-card-text class="inner-scrollbar" ref="professionalDialogId">
                <v-form
                    v-for="(professional, index) in arrProfessionals"
                    :key="index"
                    :id="index"
                    lazy-validation
                    :ref="`professional-${professional.id}`"
                    v-model="valid">
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex class="form-control">
                            <span class="select-label">{{memberProfileConstants.NAME}} {{memberProfileConstants.ASTERISK}}</span>
                            <span class="select-required">{{memberProfileConstants.REQUIRED}}</span>
                            <v-flex class="autocomplete" v-on:mouseleave="isSearchOpen=false">
                                <v-text-field
                                    required
                                    :placeholder="memberProfileConstants.NAME"
                                    color="ypo_blue"
                                    @keydown.down="onArrowDown"
                                    @keydown.up="onArrowUp"
                                    v-model="professional.name"
                                    :data-qe-id="`professional-role_${index}_name_input`"
                                    :rules="memberProfileConstants.ACCOMPLISHMENT.ACCOMPLISHMENT_NAME_RULE"
                                    @input="getSearchResults(professional)"
                                    @keydown.enter="onEnter(professional)"
                                    :maxlength="memberProfileConstants.MAX_NAME_COUNT_EIGHTY">
                                </v-text-field>
                                <v-list v-if="isSearchVisible(professional.name) && professional.isSearch" id="autocomplete-results" v-show="isSearchOpen" class="autocomplete-results">
                                    <v-list-tile
                                        class="autocomplete-result"
                                        v-for="(result, i) in results"
                                        :key="i"
                                        :data-qe-id="`professional-role_${index}_result_${i}`"
                                        @click="setResult(result, professional)"
                                        :class="{ 'is-active': i === arrowCounter }">
                                        <v-list-tile-title v-highlight = "{keyword: professional.name, sensitive: false}">
                                        {{ result }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-flex>
                            <span class="select-label">{{memberProfileConstants.WEBSITE}}</span>
                            <v-text-field 
                                :placeholder="memberProfileConstants.WEBSITE"
                                color="ypo_blue"
                                :data-qe-id="`professional-role_${index}_website-link_input`"
                                v-model="professional.url"
                                :rules="memberProfileConstants.WEBSITE_URL_RULE"
                                @input="editRoles(professional)">
                            </v-text-field>
                            <span class="select-label">{{memberProfileConstants.LOCATION}}</span>
                            <v-text-field
                                :placeholder="memberProfileConstants.LOCATION"
                                :data-qe-id="`professional-role_${index}_location_input`"
                                color="ypo_blue"
                                v-model="professional.location"
                                @input="editRoles(professional)">
                            </v-text-field>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="date">
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.START_DATE}}</span>
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                <v-autocomplete
                                                    attach
                                                    height="40"
                                                    color="ypo_blue"
                                                    :data-qe-id="`professional-role_${index}_start-date-month_select`"
                                                    :items="getFullMonthNames()"
                                                    v-model="professional.startMonth"
                                                    :placeholder="memberProfileConstants.MONTH"
                                                    @input="editRoles(professional)">
                                                </v-autocomplete>
                                            </v-flex>
                                            <v-flex xs6>
                                                <v-flex class="form-control">
                                                    <v-autocomplete
                                                        attach
                                                        height="40"
                                                        color="ypo_blue"
                                                        :data-qe-id="`professional-role_${index}_start-date-year_select`"
                                                        v-model="professional.startYear"
                                                        :items="getListOfYears()"
                                                        :placeholder="memberProfileConstants.YEAR"
                                                        @input="editRoles(professional)">
                                                        </v-autocomplete>
                                                </v-flex>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6 v-if="!professional.isCurrent" class="end-date">
                                    <span class="select-label">{{memberProfileConstants.END_DATE}}</span>
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <v-autocomplete
                                                attach
                                                height="40"
                                                color="ypo_blue"
                                                :data-qe-id="`professional-role_${index}_end-date-month_select`"
                                                :items="getFullMonthNames()"
                                                v-model="professional.endMonth"
                                                :placeholder="memberProfileConstants.MONTH"
                                                @input="editRoles(professional)">
                                            </v-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-flex class="form-control">
                                                <v-autocomplete
                                                    attach
                                                    height="40"
                                                    color="ypo_blue"
                                                    :data-qe-id="`professional-role_${index}_end-date-year_select`"
                                                    :items="getListOfYears()"
                                                    v-model="professional.endYear"
                                                    :placeholder="memberProfileConstants.YEAR"
                                                    @input="editRoles(professional)">
                                                </v-autocomplete>
                                            </v-flex>
                                        </v-flex>
                                    </v-layout>
                                    <span class="end-date__validation" v-if="invalidDate">{{memberProfileConstants.END_DATE_MUST_BE_GREATER_THAN_START_DATE}}</span>
                                </v-flex>
                            </v-layout>
                            <v-checkbox
                                v-if="headerLabel === memberProfileConstants.PROFESSIONAL_ROLES.EXTERNAL_BOARDS"
                                color="ypo_blue"
                                :data-qe-id="`professional-role_${index}_current-board-member_checkbox`"
                                v-model="professional.isCurrent"
                                :label= "memberProfileConstants.PROFESSIONAL_ROLES.BOARD_MEMBER"
                            ></v-checkbox>
                            <v-checkbox
                                v-if="headerLabel === memberProfileConstants.PROFESSIONAL_ROLES.PUBLIC_SERVICES"
                                color="ypo_blue"
                                :data-qe-id="`professional-role_${index}_current-position_checkbox`"
                                v-model="professional.isCurrent"
                                :label= "memberProfileConstants.PROFESSIONAL_ROLES.POSITION"
                            ></v-checkbox>
                            <v-checkbox
                                v-if="headerLabel === memberProfileConstants.PROFESSIONAL_ROLES.VOLUNTEER_ROLES"
                                color="ypo_blue"
                                :data-qe-id="`professional-role_${index}_current-volunteer_checkbox`"
                                v-model="professional.isCurrent"
                                :label= "memberProfileConstants.PROFESSIONAL_ROLES.VOLUNTEER_HERE"
                            ></v-checkbox>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="date">
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.INDUSTRY}}</span>
                                        <v-autocomplete
                                            attach
                                            height="40"
                                            :data-qe-id="`professional-role_${index}_industry_select`"
                                            v-model="professional.industryCategory"
                                            :items="Object.keys(industory).sort()"
                                            :placeholder="memberProfileConstants.INDUSTRY" 
                                            color="ypo_blue"
                                            v-on:input="editRoles(professional)">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-flex class="form-control">   
                                        <span class="select-label">{{memberProfileConstants.SUB_INDUSTRY}}</span>
                                        <v-autocomplete
                                            attach
                                            height="40"
                                            v-model="professional.subIndustryCategory"
                                            :items="professional.subIndustry"
                                            :data-qe-id="`professional-role_${index}_sub-industry_select`"
                                            :placeholder="memberProfileConstants.SUB_INDUSTRY" 
                                            :no-data-text="noSubIndustry(professional.subIndustry, professional.industryCategory)"
                                            color="ypo_blue"
                                            v-on:input="editRoles(professional)">
                                        </v-autocomplete>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 class="date">
                                    <v-flex class="form-control">
                                        <span class="select-label">{{memberProfileConstants.TOPIC}}</span>
                                        <v-text-field color="ypo_blue" 
                                            height="40"
                                            :placeholder="memberProfileConstants.TOPIC"
                                            v-model="professional.topic"
                                            :data-qe-id="`professional-role_${index}_topic_input`"
                                            @input="editRoles(professional)"
                                            :maxlength="memberProfileConstants.MAX_NAME_LENGTH">
                                        </v-text-field>
                                        <span class="select-label">{{memberProfileConstants.DESCRIPTION}}</span>
                                            <v-text-field class="text-number" color="ypo_blue" 
                                                :counter="255"
                                                height="40"
                                                :data-qe-id="`professional-role_${index}_description_input`"
                                                :placeholder="memberProfileConstants.DESCRIPTION"
                                                :maxlength="memberProfileConstants.MAX_LENGTH"
                                                v-model="professional.description"
                                                @input="editRoles(professional)">
                                            </v-text-field>
                                    </v-flex>
                                </v-flex>
                                <v-flex class="btn-row mt-3">
                                    <v-btn class="primary_btn"
                                        v-if="!professional.isEditDialog" 
                                        :disabled="!professional.isAdd"
                                        :data-qe-id="`professional-role_${index}_add-more_btn`"
                                        @click="addRoles(professional)">
                                        <i class="fas fa-plus-circle mr-2"></i> {{memberProfileConstants.ADD_MORE}}
                                    </v-btn>
                                    <v-btn small class="primary_btn" 
                                        @click ="deleteRoles(professional.id, index)"
                                        :data-qe-id="`professional-role_${index}_delete_btn`"
                                        :disabled="professional.isDelete">
                                        <i class="fas fa-trash-alt mr-2"></i>{{appCommonConstants.DELETE}}
                                    </v-btn>
                                    <v-flex class="save-to-profile" v-model="professional.isSuccess" v-if="professional.isSuccess">
                                        <i class="fas fa-check"></i> <span>{{memberProfileConstants.SAVED_TO_PROFILE}}</span>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                            <v-dialog v-model="deleteInformationDialog" lazy absolute content-class="post-actions">
                                <v-card>
                                    <v-flex tag="h6">{{memberProfileConstants.DIALOG_CONFIRMATION_TITLE}}
                                        <v-btn icon data-qe-id="close_dialog_btn" @click="deleteInformationDialog=false">
                                            <v-icon size="20">close</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex tag="p">
                                        {{memberProfileConstants.DIALOG_CONFIRMATION_DESC}}
                                    </v-flex>
                                    <v-flex text-xs-right>
                                        <status-bar :action="deleteRolesAction"></status-bar>
                                        <v-btn flat data-qe-id="cancel_dialog_btn" @click="deleteInformationDialog = false" class="primary_btn transparent">
                                            {{memberProfileConstants.CANCEL}}
                                        </v-btn>
                                        <v-btn dark data-qe-id="continue_dialog_btn" @click="deleteInformation()" class="primary_btn">
                                            {{memberProfileConstants.CONTINUE}}
                                        </v-btn>
                                    </v-flex>
                                </v-card>
                            </v-dialog>
                        </v-flex>
                    </v-flex>
                </v-layout>
                </v-form>
            </v-card-text>
            <status-bar :action="editProfessionalAction"></status-bar>
            <status-bar :action="saveProfessionalAction"></status-bar>
            <v-card-actions>
                <v-flex text-xs-right pa-3>
                    <v-btn class="primary_btn transparent" data-qe-id="cancel_dialog_btn2" @click="cancel()">
                        {{appCommonConstants.CANCEL}}
                    </v-btn>
                    <v-btn class="primary_btn" data-qe-id="save_dialog_btn" :disabled="!valid || invalidDate || isSave" @click="saveRoles()">
                        {{appCommonConstants.DONE}}
                    </v-btn>
                </v-flex>
            </v-card-actions>
        </v-card>
</template>

<script>
    import { memberProfileConstants, compareStartAndEndYears, noSubIndustry, filterResults } from "../memberProfile.constants.js";
    import { mapState, mapActions, mapGetters } from "vuex";
    import { getFullMonthNames, getListOfYears } from "../../../common/utils/dateTime.js";
    import { appCommonConstants } from "../../appCommon.constants.js";
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { uuid } from 'vue-uuid';
    import StatusBar from "../../StatusBar/StatusBar";
    import Vue from 'vue';

    export default {
        name: "ProfessionalRolesDialog",
        data: () => ({
            memberProfileConstants,
            appCommonConstants,
            filterResults,
            getFullMonthNames,
            getListOfYears,
            noSubIndustry,
            uuid: uuid.v1(),
            subIndustry: [],
            results: [],
            deleteInformationDialog: false,
            valid: false,
            invalidDate: false,
            isSearchLoading: false,
            isSearchOpen: false,
            professionalDeleteIndex: null,
            professionalId: null,
            arrowCounter: 0,
            postBody: {
                type: null,
                name: null,
            },
        }),
        components: {
            StatusBar,
        },
        props: {
            arrProfessionals: {
                type: Array,
                required: false,
            },
            isEditProfessional: {
                type: Boolean,
                required: false,
            },
            modelProfessionals: {
                type: Object,
                required: false,
            },
            headerLabel: {
                type: String,
                required: false,
            },
            isSave: {
                type: Boolean,
                required: false,
            },
            memberId: {
                type: String,
                required: true,
            },
        },
        methods: {
            ...mapActions({
                searchExternalConnection: `memberProfile/${storeAction.searchExternalConnection}`,
                updateProfessionalRoles: `memberProfile/${storeAction.updateProfessionalRoles}`,
                saveProfessionalRoles: `memberProfile/${storeAction.saveProfessionalRoles}`,
                deleteProfessionalRoles: `memberProfile/${storeAction.deleteProfessionalRoles}`,
            }),
            editRoles(professional) {
                professional.isEdit = true;
                professional.subIndustry = this.industory[professional.industryCategory];
                this.invalidDate = compareStartAndEndYears(professional);
                this.emitProfessionalDialog(professional);
            },
            addRoles(professional) {
                const [ref] = this.$refs[`professional-null`];
                if (ref.validate()) {
                    professional.isEditDialog = false;
                    professional.id = this.generateGUID();
                    professional.personId = this.memberId;
                    professional.isEdit = false;
                    this.setStartDate(professional);
                    this.setEndDate(professional);
                    const postBody = [{
                        ...professional,
                    }];
                    this.saveProfessionalRoles(postBody)
                        .then(() => {
                            ref.resetValidation();
                            professional.isDelete = false;
                            professional.isAdd = true;
                            professional.isSuccess = true;
                            professional.isEditDialog = true;
                            professional.isSearch = false;
                            const index = this.arrProfessionals.length;
                            setTimeout(() => {
                                document.getElementById(index).scrollIntoView();
                            }, 100);
                            this.arrProfessionals.push(Vue.util.extend({}, this.modelProfessionals));
                            this.scrollTop();
                        });
                }
            },
            deleteRoles(professionalId, index) {
                this.deleteInformationDialog = true;
                this.professionalId = professionalId;
                this.professionalDeleteIndex = index;
                this.scrollTop();
            },
            deleteInformation() {
                const parms = {
                    companyId: this.professionalId,
                    personId: this.memberId,
                };
                this.deleteProfessionalRoles(parms)
                    .then(() => {
                        this.deleteInformationDialog = false;
                        if (this.professionalDeleteIndex <= 0 && this.arrProfessionals.length === 1) {
                            this.$emit('click', false);
                        } else {
                            Vue.delete(this.arrProfessionals, this.professionalDeleteIndex);
                        }
                        this.scrollTop();
                    });
            },
            saveRoles() {
                if (this.isEditProfessional) {
                    const [ref] = this.$refs[`professional-${this.arrProfessionals[0].id}`];
                    if (ref.validate()) {
                        this.setStartDate(this.arrProfessionals[0]);
                        this.setEndDate(this.arrProfessionals[0]);
                        const postbody = {
                            ...this.arrProfessionals[0],
                        };
                        postbody.personId = this.memberId;
                        this.updateProfessionalRoles(postbody)
                            .then(() => {
                                ref.resetValidation();
                                this.$emit('click', false);
                                this.scrollTop();
                            });
                    }
                } else {
                    const postbody = this.arrProfessionals.filter(x => x.isEdit === true);
                    if (postbody.length === 0) {
                        this.addMoreValidation();
                        return false;
                    }
                    const idExists = postbody.some((el) => {
                        return el.id === null;
                    });
                    if (!idExists) {
                        this.saveRolesAPI(postbody);
                    } else {
                        const [ref] = this.$refs[`professional-null`];
                        if (ref.validate()) {
                            postbody.forEach((x) => {       
                                if (x.id === null) {
                                    x.id = this.generateGUID();
                                    this.setStartDate(x);
                                    this.setEndDate(x);
                                }
                                x.personId = this.memberId;
                            });
                            this.saveRolesAPI(postbody);
                        }
                    }
                }
            },
            saveRolesAPI(postbody) {
                this.saveProfessionalRoles(postbody)
                .then(() => {
                    this.addMoreValidation();
                });
            },
            generateGUID() {
                return uuid.v1();
            },
            getSearchResults(professional) {
                professional.isEdit = true;
                professional.isSearch = true;
                this.emitProfessionalDialog(professional);
                if (professional.name && professional.name.length >= this.memberProfileConstants.THREE) {
                    this.postBody.type = professional.type;
                    this.postBody.name = professional.name;
                    this.isSearchLoading = true;
                    this.searchExternalConnection(this.postBody)
                        .then(() => {
                            this.results = this.filterResults(this.professionalRolesSearchResult, professional.name);
                            this.isSearchOpen = true;
                            this.isSearchLoading = false;
                        });
                }
            },
            setResult(result, professional) {
                professional.name = result;
                this.isSearchOpen = false;
            },
            onArrowDown() {
                if (this.arrowCounter < this.results.length) {
                    this.arrowCounter = this.arrowCounter + 1;
                }
            },
            onArrowUp() {
                if (this.arrowCounter > 0) {
                    this.arrowCounter = this.arrowCounter - 1;
                }
            },
            onEnter(professional) {
                professional.name = this.results[this.arrowCounter];
                this.isSearchOpen = false;
                this.arrowCounter = -1;
            },
            setStartDate(professional) {
                if (professional.startMonth && professional.startYear) {
                    professional.startDate = `${professional.startMonth} ${professional.startYear}`;
                } else {
                    professional.startDate = null;
                }
            },
            setEndDate(professional) {
                if (professional.endMonth && professional.endYear) {
                    professional.endDate = `${professional.endMonth} ${professional.endYear}`;
                } else {
                    professional.endDate = null;
                }
            },
            isSearchVisible(professionalName) {
                if (professionalName !== undefined && professionalName !== null) {
                    return professionalName.length >= this.memberProfileConstants.THREE && this.results.length > 0;
                }
                return false;
            },
            cancel() {
                this.$emit('input', true);
                this.resetValidation();
                this.$emit('click', false);
                this.scrollTop();
            },
            scrollTop() {
                if (this.$refs.professionalDialogId) {
                    this.$refs.professionalDialogId.scrollTop = 0;
                }
            },
            resetValidation() {
                this.arrProfessionals.forEach((x) => {
                    const [ref] = this.$refs[`professional-${x.id}`];
                    if (ref && ref.resetValidation) {
                        ref.resetValidation();
                    }
                });
                this.invalidDate = false;
            },
            emitProfessionalDialog(professional) {
                professional.isAdd = !!professional.name;
                this.$emit('input', !professional.name);
            },
            addMoreValidation() {
                this.$emit('click', false);
                this.scrollTop();
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                industory: `memberProfile/${storeGetters.externalConnectionIndustry}`,
                professionalRolesSearchResult: `memberProfile/${storeGetters.courseAndCertificateSearchResult}`,
            }),
            deleteRolesAction() {
                return this.actions[storeAction.deleteProfessionalRoles];
            },
            saveProfessionalAction() {
                return this.actions[storeAction.saveProfessionalRoles];
            },
            editProfessionalAction() {
                return this.actions[storeAction.updateProfessionalRoles];
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";

    .save-to-profile {
        display: initial;
        color: $ypo_blue;
        margin-left: 15px;

        i {
            margin-right: 8px;
        }
    }

    .v-card {
        .select-required {
            color: $ypo-blue;
            font-size: 14px;
            font-weight: bold;
            line-height: 20px;
            margin-left: 608px;
            @media (max-width: 767px){
                display: none;
            }
        }

        .date {
            margin-left: -7px;
        }

        .end-date {
            position: relative;
            &__validation {
                position: absolute;
                color: $ypo-red;
                font-size: 12px;
                bottom: 0;
            }
        }
    }
</style>
